import ActionTypes from '../ActionTypes';

export function updateDateRange(string) {
  return {
    type: ActionTypes.RateQuote.updateDateRange,
    string,
  };
}

export function updateDateString(string) {
  return {
    type: ActionTypes.RateQuote.updateDateString,
    string,
  };
}

export function toggleDatePicker(string) {
  return {
    type: ActionTypes.RateQuote.toggleDatePicker,
    string,
  };
}

export function updateString(fieldName, value) {
  return {
    type: ActionTypes.RateQuote.updateString,
    fieldName,
    value,
  };
}



// WEBPACK FOOTER //
// /src/store/actions/RateQuoteActions.js